<template>
  <div class="wrapper">
    <transition name="slimdown">
      <div class="errorMsg" v-if="isError">
        Упс, кажется возникла ошибка :( <br />
        Попробуйте позже.
      </div>
    </transition>
    <div class="logo">
      <img alt="logo" :src="referalLogo" />
    </div>
    <h1 class="title">Присоединяйся и получай бонусы!</h1>
    <div class="formBox">
      <p>
        Для участия в программе лояльности, укажите свой номер, который будет
        использоваться в дальнейшем для входа в приложение
      </p>
      <input v-model="phoneNumber" type="tel" placeholder="+7" />
    </div>
    <div class="checkboxBox" :class="{ active: isAgree }">
      <div
        :style="{
          backgroundColor: corporateColor,
        }"
        @click.self="isAgree = !isAgree"
        class="checkbox"
      ></div>
      <span class="label">
        Я солашаюсь
        <a class="link" :href="termsOfUseLink"> с условиями использования </a>
        и
        <a class="link" :href="privacyPolicyLink">
          политикой конфидинциальности
        </a>
      </span>
    </div>
    <button
      :style="{
        backgroundColor:
          isAgree && realNumber.length >= 11 ? corporateColor : '',
      }"
      :class="{
        disable: !isAgree || realNumber.length < 11,
      }"
      @click="submit"
      class="sbmBtn"
    >
      Продолжить
    </button>
  </div>
</template>

<script>
export default {
  name: "Referal",

  data() {
    return {
      isAgree: false,
      phoneNumber: "+7",
      realNumber: "",
    };
  },

  props: {
    isError: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    termsOfUseLink() {
      return process.env.VUE_APP_REFERAL_TERMS_OF_USE_LINK;
    },
    privacyPolicyLink() {
      return process.env.VUE_APP_REFERAL_PRIVACY_POLICY_LINK;
    },
    referalLogo() {
      return process.env.VUE_APP_REFERAL_LOGO;
    },

    corporateColor() {
      return process.env.VUE_APP_CORPORATE_COLOR;
    },

    query() {
      return this.$route.query;
    },
  },

  watch: {
    phoneNumber(newVal, oldVal) {
      if (newVal === "" || newVal === "+") {
        this.phoneNumber = "+7";
        return;
      }
      if (newVal.length > 18) {
        this.phoneNumber = oldVal;
        return;
      }

      const num = newVal.replace(/\D/g, "").split(/(?=.)/);
      const i = num.length - 1;
      if (0 <= i) num.unshift("+");
      if (1 <= i) num.splice(2, 0, " (");
      if (4 <= i) num.splice(6, 0, ") ");
      if (7 <= i) num.splice(10, 0, "-");
      if (9 <= i) num.splice(13, 0, "-");
      this.phoneNumber = num.join("");
      this.realNumber = this.phoneNumber
        .replaceAll("+", "")
        .replaceAll(" (", "")
        .replaceAll(") ", "")
        .replaceAll("-", "");
    },
  },

  methods: {
    submit() {
      const data = {
        phoneNumber: this.realNumber,
        isAgree: this.isAgree,
        stringNumber: this.phoneNumber,
        query: this.query,
      };
      if (data.phoneNumber.length < 11 || !data.isAgree) {
        return;
      }
      this.$emit("submitData", data);
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  flex-direction: column;
  max-height: 85%;
}

.logo {
  width: 88px;
  height: 88px;
  margin: 27px auto 0 auto;

  border-radius: 16px;
  overflow: hidden;

  img {
    display: block;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.title {
  background: transparent;
  margin-top: 48px;
}

.formBox {
  margin: 24px 6px 0 6px;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0 7px 29px 0 #64646f;

  p {
    font-size: 12px;
    line-height: 18px;
    text-align: center;
  }

  input {
    width: 100%;
    height: 48px;
    border: none;
    margin-top: 16px;
    background-color: #f7f7fd;
    font-size: 16px;
    padding: 0 20px;
  }
}

.checkboxBox {
  margin: 24px 6px 0 6px;
  display: flex;
  gap: 16px;

  .checkbox {
    background: #e94b26;
    border-radius: 4px;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  }

  &.active .checkbox {
    background-image: url("/src/assets/img/checkbox.svg");
    background-repeat: no-repeat;
    background-position: center;
  }

  .link {
    text-decoration: underline;
  }
}

.sbmBtn {
  display: block;
  margin: auto auto 0 auto;
  width: 97%;
  padding: 0;
  height: 56px;
  background: #2e7d32;
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  pointer-events: all;

  &.disable {
    background: grey;
    pointer-events: none;
  }
}

.errorMsg {
  position: absolute;
  outline: 1px solid #e94b26;
  left: 50%;
  transform: translate(-50%, 29px);
  background: white;
  border-radius: 8px;
  padding: 4px;
  text-align: center;
}

.slimdown-enter-active,
.slimdown-leave-active {
  transform: translate(-50%, 29px);
  opacity: 1;
  transition: all 0.5s ease;
}

.slimdown-enter-from,
.slimdown-leave-to {
  transform: translate(-50%, -50px);
  opacity: 0;
}
</style>
